export const ECompanyMemberRoleStatus = {
  Active: "active",
  Deactivated: "deactivated",
  Invited: "invited",
} as const;

export type ECompanyMemberRoleStatus =
  (typeof ECompanyMemberRoleStatus)[keyof typeof ECompanyMemberRoleStatus];
